module.exports = __webpack_public_path__ + "img/day15.2554d93a.jpeg";